module.exports = __webpack_public_path__ + "static/img/hujiao.90d7e3b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/black/hujiao.png
// module id = 01+5
// module chunks = 24